module.exports = __webpack_public_path__ + "static/img/a2g.03469e88.webp";